

























import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import BaseDialogComponent from '../common/BaseDialog.vue';
import PickerDialogComponent from '../common/PickerDialog.vue';

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
    picker: PickerDialogComponent,
  },
})

export default class LoadRunsDialogComponent extends Vue {
  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  @Watch("commandFlag")
  onCommandFlagChanged() {
    if (this.commandFlag === 2) {
      if (this.programRunId === -1) {
        this.programRunId = 0;
      }
    }
    else if (this.programRunId !== -1) {
      this.programRunId = -1;
    }
  }

  @Watch("programRunId")
  onProgramRunIdChanged() {
    if (this.programRunId < 0 || this.programRunId > 255) {
      if (this.programRunIdErrors.length === 0) {
        this.programRunIdErrors = [
          this.$t("panelControl.runIdError").toString(),
        ];
      }
    }
    else {
      this.programRunIdErrors = [];
    }
  }

  title = this.$t("panelDetail.actions.loadRuns").toString();

  programRunIdErrors: string[] = [];

  isLoading = false;

  command = 10;
  commandFlag = 0;
  programRunId = -1;

  commandFlagOptions = [0, 2];

  resolve?: (value: { programRunId: number }) => void = undefined;
  reject?: (reason: string) => void = undefined;

  closeButtonText = this.$t("common.close").toString();
  executeButtonText = this.$t("common.execute").toString();

  get isProgramRunIdFieldDisabled() {
    return this.commandFlag !== 2;
  }

  formatCommandFlagOptions(value: 0 | 2) {
    return this.$t(`panelDetail.loadRunsOptions.${value === 2 ? "startFromRunId" : "startFromBeginning"}`).toString();
  }

  async onSave() {
    if (this.resolve) {
      this.resolve({
        programRunId: this.programRunId,
      });
    }
  }

  async onCancel() {
    this.baseDialogComponent.isShowing = false;
  }

  async show() {
    const title = this.title;
    const positiveButtonText = this.executeButtonText;
    const negativeButtonText = this.closeButtonText;

    this.baseDialogComponent.show({
      title: title,
      positiveButtonText: positiveButtonText,
      negativeButtonText: negativeButtonText,
      closeOnSave: true,
      maxWidth: 600,
    });

    return new Promise<{ programRunId: number }>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
}
